// extracted by mini-css-extract-plugin
export default {"single-testimonial-module":"single-testimonial-module--PaW9e","singleTestimonialModule":"single-testimonial-module--PaW9e"};